
    <div class="roulette-wheel-wrap">
      <div class="roulette-wheel" [ngStyle]="{ transform: 'rotateZ(-' + deg + 'deg)' }">
        <div class="roulette-normal-wheel" [class.bonus]="bonusWheel"></div>
        <div class="roulette-borders"></div>
        <div class="roulette-center"></div>
      </div>
      <div class="roulette-pointer"></div>
    </div>
  


// WEBPACK FOOTER //
// /var/lib/jenkins/workspace/Prod_web-client/src/app/shared/components/reply/reply-roulette.component.ts.ReplyRouletteComponent.html